import actions from 'redux/actions'
import constants from 'common/helpers/constants'
import mixpanel from 'common/helpers/analytics/mixpanel'
import getCookieValue from 'helpers/getCookieValue'
import formatPrice from 'common/helpers/modifiers/formatPrice'
import getAuthorizationFee from 'common/helpers/getters/getAuthorizationFee'

import messages from './messages'


const getBillData = (values = {}) => {
  const {
    gender, selectedPlan, subscriptionCasePrice,
    bill: {
      price = 0,
      tax = 0,
      upchargePrice,
      offer: billOffer,
      discount: billDiscount = 0,
      creditCardAuthorizationFee = 0,
    } = {},
    subscription: { price: subscriptionPrice, shipping: subscriptionShippingPrice, discount: subscriptionDiscount } = {},
    coupon: { code } = {},
    paymentMethod,
  } = values

  const items         = []
  const offerCookie   = getCookieValue(constants.cookieNames.offer, true)
  const couponCookie  = getCookieValue(constants.cookieNames.discountCoupon, true)
  const offer         = billOffer || offerCookie // TODO mbe we should always take offer from inquire response?

  const { authorizationFee } = getAuthorizationFee({
    creditCardAuthorizationFee,
    isCreditCard: paymentMethod === constants.paymentMethods.creditCard,
  })

  // Product ------------------------------------------------------------ /

  let productValue = formatPrice(subscriptionPrice, true)
  let productCountPerMonth = 1

  if (/_2PCS/.test(selectedPlan)) {
    productCountPerMonth = 2
  }
  else if (/_3PCS/.test(selectedPlan)) {
    productCountPerMonth = 3
  }

  items.push({
    id: 'billSubscriptionProductRow',
    label: messages.product.monthlySubscription,
    note: { ...messages.productsPerMonth, values: { count: productCountPerMonth } },
    value: productValue,
    amount: formatPrice(subscriptionPrice, true, false),
  })

  // Case subscription  ------------------------------------------------ /

  if (subscriptionCasePrice) {
    items.push({
      id: 'billSubscriptionCasePriceRow',
      label: messages.caseSubscription,
      value: formatPrice(subscriptionCasePrice, true),
      amount: formatPrice(subscriptionCasePrice, true, false),
      onRemove: () => {
        mixpanel.track(constants.analyticsEvents.casesSubscription.remove)
        actions.models.payment.setSubscriptionCaseStatus(false)
      },
    })
  }

  // Upcharge ---------------------------------------------------------- /

  if (upchargePrice) {
    items.push({
      id: 'billSubscriptionUpchargeRow',
      label: messages.upcharge.label,
      note: messages.upcharge.note,
      value: formatPrice(upchargePrice, true),
      amount: formatPrice(upchargePrice, true, false),
    })
  }

  // Shipping ----------------------------------------------------------- /

  items.push({
    id: 'billSubscriptionShippingRow',
    label: messages.shipping,
    value: subscriptionShippingPrice ? formatPrice(subscriptionShippingPrice, true) : messages.free,
    amount: formatPrice(0, true, false),
    brand: true,
  })

  // Tax ---------------------------------------------------------------- /

  items.push({
    id: 'billTaxRow',
    label: messages.tax,
    value: formatPrice(tax, true),
    amount: formatPrice(tax, true, false),
  })

  // Discount ----------------------------------------------------------- /

  let discountLabel
  let discountValue
  let discountApplePayValue = formatPrice(billDiscount, true, false)

  const isOfferForFirstMonth = Object.values(constants.firstMonthCoupons).includes(code)

  if (subscriptionDiscount) {
    discountLabel = messages.discount.subscription
    discountValue = typeof subscriptionDiscount === 'string'
      ? subscriptionDiscount
      : formatPrice(subscriptionDiscount, true)
  }

  if (offer === constants.offerNames.secondMonthFree) {
    discountLabel = { ...messages.discount.secondMonthFree, values: { gender } }
    discountValue = messages.free
    discountApplePayValue = formatPrice(0, true, false)
  }
  else if (couponCookie === constants.discountCoupons.fivemonthdiscount) {
    discountLabel = messages.discount.common
  }

  if (discountLabel && discountValue) {
    items.push({
      id: 'billSubscriptionDiscountRow',
      label: discountLabel,
      value: discountValue,
      amount: discountApplePayValue,
      brand: true,
      note: isOfferForFirstMonth ? messages.offerNote : null,
    })
  }

  // Authorization --------------------------------------------------------- /

  if (authorizationFee) {
    items.push({
      id: 'billSubscriptionAuthorizationRow',
      value: formatPrice(authorizationFee, true),
      amount: formatPrice(authorizationFee, true, false),
      label: ({ paymentMethod }) => paymentMethod === constants.paymentMethods.creditCard
        ? messages.creditCardAuthorization
        : messages.payPalAuthorization,
    })
  }

  // Total ---------------------------------------------------------------- /

  let total = price || 0

  if (authorizationFee) {
    total += authorizationFee
  }

  return {
    items,
    total,
  }
}


export {
  getBillData,
}
